var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.3 3.493h5.4V2.3h1.4v1.259a2 2 0 0 1 1.5 1.934V12l-.01.204a2 2 0 0 1-1.785 1.785L11.6 14H4.4l-.205-.01a2 2 0 0 1-1.785-1.786L2.401 12V5.493c0-.932.637-1.712 1.5-1.934v-1.26h1.4zM3.9 12a.5.5 0 0 0 .5.5h7.2a.5.5 0 0 0 .5-.5V7.95H3.9zm.5-7.007a.5.5 0 0 0-.5.5v.957h8.2v-.957a.5.5 0 0 0-.5-.5z"
  })));
};
export default SvgCalendar;